import { useState, useEffect } from "react";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Bio from "@/components/Bio";
import Gigs from "@/components/Gigs";
import Mixes from "@/components/Mixes";
import Gallery from "@/components/Gallery";
import Booking from "@/components/Booking";
import Footer from "@/components/Footer";

export default function Landing() {
  useLenis();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <main
      data-testid="landing-page"
      className={`relative min-h-screen bg-[#050505] text-[#F5F5F5] transition-opacity duration-700 ${
        loaded ? "opacity-100" : "opacity-0"
      }`}
    >
      <Navbar />
      <Hero />
      <Marquee text="DISKO BHUTE · THE MIDNIGHT SOUND" />
      <Bio />
      <Gigs />
      <Marquee text="DARK MINIMAL · PSY TECH · HYPNOTIC" reverse />
      <Mixes />
      <Gallery />
      <Booking />
      <Footer />
    </main>
  );
}
